import { render, staticRenderFns } from "./financialReview.vue?vue&type=template&id=3addb16e&scoped=true"
import script from "./financialReview.vue?vue&type=script&lang=js"
export * from "./financialReview.vue?vue&type=script&lang=js"
import style0 from "./financialReview.vue?vue&type=style&index=0&id=3addb16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3addb16e",
  null
  
)

export default component.exports